import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  isDataLoading: false,
  isCentralDataLoading: false,
  isViewDataLoading: false,
  isDistributionLoading: false,
  isSaving: false,
  error: null,
  data: {}
};

function isLoadingKey(str) {
  return `is${str.charAt(0).toUpperCase()}${str.substring(1)}Loading`;
}

export default function(state = initialState, action) {
  const dataKey = action.dataType || 'data';
  switch (action.type) {
    case Constants.REQUEST_SAVE_BLOCK_DATA: // from MM
      return { ...state, isSaving: true };
    case Constants.RECEIVE_SAVE_BLOCK_DATA: // from MM
      if (action.error) {
        return { ...state, isSaving: false, error: action.error };
      }
      return {
        ...state,
        isSaving: false,
        messageId: action.data.message_id,
        spotlight_distribution: action.data.spotlight_distribution,
        page: {
          id: action.data.block_id,
          link: action.data.link
        }
      };
    case Constants.REQUEST_BLOCK_DATA: // from SDK
      return {
        ...state,
        isLoading: true,
        [isLoadingKey(action.dataType)]: true
      };
    case Constants.RECEIVE_MESSAGE_BLOCKS:
      if (action.error) {
        return {
          ...state,
          error: action.error
        };
      }
      return {
        ...state,
        messageBlocks: action.data?.blocks || []
      };
    case Constants.RECEIVE_BLOCK_DATA: // from SDK -- after block data or central data is fetched
      const loadingKey = isLoadingKey(action.dataType);
      if (action.error) {
        return {
          ...state,
          isLoading: false,
          [loadingKey]: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        [loadingKey]: false,
        [dataKey]: {
          ...state[dataKey],
          ...action[dataKey]
        }
      };
    case Constants.RECEIVE_SAVE_BLOCK_SDK_DATA: // from SDK -- after block data or central is saved
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        [dataKey]: {
          ...state[dataKey],
          ...action[dataKey]
        }
      };
    case Constants.REQUEST_BLOCK_DISTRIBUTION:
      return { ...state, isDistributionLoading: true };
    case Constants.RECEIVE_BLOCK_DISTRIBUTION:
      if (action.error) {
        return { ...state, isDistributionLoading: false, error: action.error };
      }
      return {
        ...state,
        isDistributionLoading: false,
        spotlight_distribution: { ...action.data }
      };
    case Constants.RECEIVE_USER_DATA: // locale from SDK
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        userData: { ...action.data }
      };
    default:
      return state;
  }
}
